import { routes } from "src/shared/routes";
import { FAQS, REGISTRATION_CARDS } from "./helper";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

import LogoImage from "public/images/utahjazz/utah-jazz-logo.png";
import BannerImage from "public/images/utahjazz/Banner_AttendPage.png";
import MobileBannerImage from "public/images/utahjazz/GFX_AttendPage.png";

export const seatgeek_sandbox: TTeamConfig = {
  TEAM_SCHEMA: "seatgeek_sandbox",
  TEAM_FULL_NAME: "SeatGeek Sandbox",
  BROWSER_TITLE: "SeatGeek Sandbox Pass",
  CLIENT_ID: "",
  VENDOR: "SEATGEEK",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#3E2680",
    COLORS_SECONDARY: "#3E2680",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
  },

  LANDING_PAGE_SETTINGS: {
    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
    },
    PASS_BANNER: {
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },
    SHOW_ALL_EVENTS_UNDER_PASS: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: LogoImage.src,
    LANDING_PAGE_STATIC_BANNER_URL: BannerImage.src,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: MobileBannerImage.src,
    FOOTER_LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA 2024-25/jazz-v3-assets/JAZ2425_Primary_RGB_White.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202024-25/jazz-v3-assets/2N5A2951.jpeg",
  },

  LANGUAGES: {
    FAQS,
  },
};
